import React, { useState } from 'react'
import BEMHelper from '@/helpers/bem'
import styles from './Styles.module.scss'

interface VideoLoadingProps {}

const bem = BEMHelper(styles)

const VideoLoading: React.FC<VideoLoadingProps> = () => {
  const [isVisible, setIsVisible] = useState(true)

  const handleAnimationEnd = () => {
    if (!isVisible) {
      // Hide the component after fade-out animation completes
      setIsVisible(false)
    }
  }

  return (
    <div {...bem('', isVisible ? 'fade-in' : 'fade-out')} onAnimationEnd={handleAnimationEnd}>
      <span {...bem('text')}>Laster...</span>
    </div>
  )
}

export default VideoLoading
